import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import {Tag, TAG_SIZES} from '@adv-mt/ui/tag'
import {Body2} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './config.js'
import {
  getCommitmentMonths,
  getCommitmentMonthsLabel,
  getKmAllowanceKey,
  getKmAllowanceLabel,
  getKmAllowances,
  getMatchingOptions
} from './utils.js'

const RentingOptions = ({
  onCommitmentMonthsSelected,
  onKmAllowanceSelected,
  selectedCommitmentMonths,
  selectedKmAllowance,
  subscriptionPriceOptions
}) => {
  const {i18n, domain} = useContext(Context)

  const isHigherThanMobile = useMediaQuery(useMediaQueryBreakpoints.sm, {
    defaultMatches: !domain.get('config').get('isMobile')
  })

  const tagSize = isHigherThanMobile ? TAG_SIZES.SMALL : TAG_SIZES.MEDIUM

  const isUnavailable = ({commitmentMonths, kmAllowance}) =>
    getMatchingOptions({commitmentMonths, kmAllowance, subscriptionPriceOptions}).length === 0

  return (
    <div className={`${BASE_CLASS}-options`}>
      <div className={`${BASE_CLASS}-optionGroup`}>
        <Body2 className={`${BASE_CLASS}-optionLabel`} highlight>
          {i18n.t('COMMON.COMMITMENT')}
        </Body2>
        <div className={`${BASE_CLASS}-optionTags`}>
          {getCommitmentMonths(subscriptionPriceOptions).map(commitmentMonths => (
            <Tag
              disabled={isUnavailable({commitmentMonths, kmAllowance: selectedKmAllowance})}
              key={commitmentMonths}
              onClick={() => onCommitmentMonthsSelected(commitmentMonths)}
              selected={commitmentMonths === selectedCommitmentMonths}
              size={tagSize}
            >
              {getCommitmentMonthsLabel({commitmentMonths, i18n})}
            </Tag>
          ))}
        </div>
      </div>

      <div className={`${BASE_CLASS}-optionGroup`}>
        <Body2 className={`${BASE_CLASS}-optionLabel`} highlight>
          {i18n.t('COMMON.MILEAGE_INCLUDED')}
        </Body2>
        <div className={`${BASE_CLASS}-optionTags`}>
          {getKmAllowances(subscriptionPriceOptions).map(kmAllowance => (
            <Tag
              disabled={isUnavailable({commitmentMonths: selectedCommitmentMonths, kmAllowance})}
              key={getKmAllowanceKey(kmAllowance)}
              onClick={() => onKmAllowanceSelected(kmAllowance)}
              selected={
                Boolean(selectedKmAllowance) &&
                getKmAllowanceKey(kmAllowance) === getKmAllowanceKey(selectedKmAllowance)
              }
              size={tagSize}
            >
              {getKmAllowanceLabel({kmAllowance, i18n})}
            </Tag>
          ))}
        </div>
      </div>
    </div>
  )
}

RentingOptions.displayName = 'RentingOptions'
RentingOptions.propTypes = {
  onCommitmentMonthsSelected: PropTypes.func.isRequired,
  onKmAllowanceSelected: PropTypes.func.isRequired,
  selectedCommitmentMonths: PropTypes.number,
  selectedKmAllowance: PropTypes.shape({
    kmIncluded: PropTypes.number,
    kmIncludedPeriod: PropTypes.string
  }),
  subscriptionPriceOptions: PropTypes.array.isRequired
}

export default RentingOptions
